import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classNames from 'classnames';
import swal from 'sweetalert2';
import isEmpty from 'lodash/isEmpty';

import {copyTextToClipboard} from '../../../../../helpers/utils';
import selectEntities from '../../../../../selectors/entities';
import TournamentInfos from './components/Infos';

import './TournamentInfoWidget.css';
import Loader from '../../../../../components/Loader';
import {fetchTournamentIfNeeded} from '../../../../../actions/app/support/tournament';
import {getEndpoint, getHeaders} from '../../../../../helpers/endpoint';
import {getChampionships} from '../../../../../actions/entities/championships';

export const getTournamentUsers = payload => {
  return (_dispatch, getState) => {
    fetch(getEndpoint('getTournamentUsers', payload.tournamentId), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
        } else {
          payload.onSuccess(data);
        }
      });
  };
};

class TournamentInfoWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tournamentId: props.tournamentId || '',
      name: props.name || '',
    };
  }

  fetchTournamentInfo(e) {
    if (e) e.preventDefault();
    const {tournamentId} = this.state;
    this.props.dispatch(
      getTournamentUsers({
        tournamentId: 'mpg_tournament_' + tournamentId,
        onSuccess: tournamentUsers => this.setState({tournamentUsers}),
      }),
    );
    this.props.dispatch(fetchTournamentIfNeeded(tournamentId));
    this.props.dispatch(getChampionships());
  }

  static copyToClipboard(email) {
    const success = copyTextToClipboard(email);
    success
      ? swal(`Copied!`, `${email} is in your clipboard.`, 'success')
      : swal(`Oops...`, `We couldn't copy ${email}`, 'error');
  }

  renderNoResult() {
    const {info} = this.props.widget;
    const {error} = info;

    return (
      <div className="no-result text-center">
        <h4 className="text-muted">Want to find a particular tournament ?</h4>
        <form
          className="form-inline"
          onSubmit={e => this.fetchTournamentInfo(e)}>
          <div
            className={classNames('form-group', {
              'has-error': error === 'tournamentNotFound',
            })}>
            <div className="input-group input-group">
              <input
                type="text"
                className="form-control"
                placeholder="qFLv1HS36eh"
                value={this.state.tournamentId}
                onChange={e => this.setState({tournamentId: e.target.value})}
              />
              <span className="input-group-btn">
                <button
                  type="button"
                  className="btn btn-primary btn-flat"
                  onClick={this.fetchTournamentInfo.bind(this)}>
                  <i className="fa fa-search" />
                </button>
              </span>
            </div>
            {error === 'tournamentNotFound' && (
              <span className="help-block">
                We couldn't find tournament {info.lastPayload.tournamentId}
              </span>
            )}
          </div>
        </form>
      </div>
    );
  }

  renderBody() {
    const {tournamentUsers, name} = this.state;
    const {tournament, championship} = this.props;
    const {entity = {}} = tournament;

    let handleNameChange = e => {
      this.setState({name: e.target.value});
    };

    if (isEmpty(entity) || isEmpty(tournamentUsers))
      return this.renderNoResult();

    return (
      <div className="result">
        <TournamentInfos
          entity={entity}
          championship={championship}
          tournamentUsers={tournamentUsers}
          name={name}
          handleNameChange={handleNameChange}
        />
      </div>
    );
  }

  renderFooter() {
    const {entity} = this.props.tournament;

    return (
      entity && (
        <div className="box-footer form-inline">
          <form
            onSubmit={e => this.fetchTournamentInfo(e)}
            className="input-group margin-r-5 pull-right">
            <input
              type="text"
              className="form-control"
              placeholder="qqAAbGUlC9L"
              value={this.state.tournamentId}
              onChange={e => this.setState({tournamentId: e.target.value})}
            />
            <span className="input-group-btn">
              <button
                type="button"
                className="btn btn-default btn-flat"
                onClick={this.fetchTournamentInfo.bind(this)}>
                <i className="fa fa-search" />
              </button>
            </span>
          </form>
        </div>
      )
    );
  }

  render() {
    const {info} = this.props.widget;

    return (
      <div id="league-info-widget" className="row">
        <div className="col-md-12">
          <div className="box box-default">
            <div className="box-header with-border">
              <h3 className="box-title pull-left">
                <i className="fa fa-info-circle" /> Tournament info
              </h3>
              <div className="box-tools pull-right">
                <button
                  type="button"
                  className="btn btn-box-tool"
                  data-widget="collapse">
                  <i className="fa fa-minus" />
                </button>
              </div>
            </div>
            <div className="box-body">{this.renderBody()}</div>
            {this.renderFooter()}
            {info.isFetching && <Loader />}
          </div>
        </div>
      </div>
    );
  }
}

TournamentInfoWidget.propTypes = {
  tournamentId: PropTypes.string,
};

export default connect(
  state => {
    const {tournaments} = state.entities;
    const {championships} = state.app;
    const widget = state.app.support.tournament;
    const entity = selectEntities(tournaments, [widget.id])[0];

    return {
      widget,
      token: state.authentication.token,
      tournament: {entity: selectEntities(tournaments, [widget.id])[0]},
      championship:
        championships.list.data?.[entity?.gameSettings?.championshipId],
    };
  },
  dispatch => ({dispatch}),
)(TournamentInfoWidget);



// WEBPACK FOOTER //
// ./src/pages/Support/Tournament/Widgets/TournamentInfo/index.js